import type { ReactElement } from "react";
import { ChevronRight } from "@tamagui/lucide-icons";
import { Paragraph2, XStack, YStack } from "@medbillai/ui";
export type GetHelpPromptProps = {
  title: string;
  description: string;
  badge: ReactElement;
  onPress: () => void;
  labelBadge?: ReactElement;
};
export function GetHelpPrompt({
  title,
  description,
  badge,
  labelBadge,
  onPress
}: GetHelpPromptProps) {
  return <XStack onPress={onPress} gap="$4" py="$3" pl="$5" pr="$4" alignItems="center" hoverStyle={{
    backgroundColor: "$backgroundPress"
  }} pressStyle={{
    backgroundColor: "$backgroundPress"
  }} cursor="pointer" data-sentry-element="XStack" data-sentry-component="GetHelpPrompt" data-sentry-source-file="GetHelpPrompt.tsx">
      {badge}

      <YStack flex={1} gap="$1" data-sentry-element="YStack" data-sentry-source-file="GetHelpPrompt.tsx">
        <XStack gap="$2" data-sentry-element="XStack" data-sentry-source-file="GetHelpPrompt.tsx">
          <Paragraph2 color="$navy12" bold data-sentry-element="Paragraph2" data-sentry-source-file="GetHelpPrompt.tsx">
            {title}
          </Paragraph2>
          {labelBadge}
        </XStack>
        <Paragraph2 color="$textSecondary" data-sentry-element="Paragraph2" data-sentry-source-file="GetHelpPrompt.tsx">{description}</Paragraph2>
      </YStack>

      <ChevronRight size={24} color="$cream10" data-sentry-element="ChevronRight" data-sentry-source-file="GetHelpPrompt.tsx" />
    </XStack>;
}